export default "__VITE_ASSET__B$YDfC2q__"